import Constants from '../../../app/utils/constants'
import colors from '../../theme/color'

const ContactInfoCards = () => {
  const { contactUsSection } = Constants

  const getActionLink = (title: string, description: string) => {
    if (title.toLowerCase().includes('office address')) {
      return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(description)}`
    }

    if (title.toLowerCase().includes('call')) {
      const phone = description.replace(/[^\d+]/g, '')
      return `tel:${phone}`
    }

    if (
      title.toLowerCase().includes('support') ||
      title.toLowerCase().includes('email')
    ) {
      return `mailto:${description.trim()}`
    }

    return null
  }

  const handleCardAction = (link: string | null) => {
    if (!link) return

    if (link.startsWith('https://')) {
      window.open(link, '_blank', 'noopener,noreferrer')
      return
    }

    if (link.startsWith('mailto:')) {
      const email = link.replace('mailto:', '').trim()

      window.location.href = link

      window.setTimeout(() => {
        window.open(
          `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(email)}`,
          '_blank',
          'noopener,noreferrer'
        )
      }, 300)

      return
    }

    window.location.href = link
  }

  return (
    <section
      className="w-full px-4 py-4 md:px-8 lg:px-20 2xl:px-60"
      style={{ backgroundColor: colors.contactInfoCardsBg }}
    >

      <style>{`
        @keyframes orbitDot {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        @keyframes orbitDotReverse {
          from {
            transform: rotate(360deg);
          }
          to {
            transform: rotate(0deg);
          }
        }
      `}</style>

      <div className="grid grid-row-3 md:gap-5 md:grid-cols-3 lg:grid-cols-3">

        {contactUsSection.infoItems.map((item) => {

          const actionLink = getActionLink(
            item.title,
            item.description
          )

          const contactIconStyle = {
            WebkitMaskImage: `url(${item.icon})`,
            maskImage: `url(${item.icon})`,
            WebkitMaskRepeat: 'no-repeat',
            maskRepeat: 'no-repeat',
            WebkitMaskPosition: 'center',
            maskPosition: 'center',
            WebkitMaskSize: 'contain',
            maskSize: 'contain',
          } as const

          return (
            <article
              key={item.title}
              className=" flex flex-row items-center gap-6 t md:flex-col md:justify-start md:tex h-full min-h-[100px] md:min-h rounded-xl md:px-5 md:py-5 transition-transform duration-200 hover:-translate-y-0.5 cursor-pointer
              "
              role="button"
              tabIndex={0}
              onClick={() => handleCardAction(actionLink)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  handleCardAction(actionLink)
                }
              }}
            >

              {/* ICON */}
              <div className="group/circle relative flex shrink-0 h-18 w-18 items-center justify-center rounded-full border-2 border-dashed border-gray-200/20 p-1.5 md:mx-auto md:h-14 md:w-14 lg:h-17 lg:w-17 xl:h-20 xl:w-20 2xl:h-28 2xl:w-28">

                {/* ORBIT DOT */}
                <span
                  aria-hidden
                  className="pointer-events-none absolute inset-0 rounded-full"
                  style={{
                    animation: 'orbitDot 5.5s linear infinite',
                  }}
                >
                  <span className="absolute -top-1 left-1/2 h-2 w-2 -translate-x-1/2 rounded-full bg-white/90 shadow-[0_0_8px_rgba(255,255,255,0.6)]" />
                </span>

                {/* ORBIT DOT REVERSE */}
                <span
                  aria-hidden
                  className="pointer-events-none absolute inset-0 rounded-full"
                  style={{
                    animation:
                      'orbitDotReverse 7s linear infinite',
                  }}
                >
                  <span className="absolute top-1/2 -right-1 h-1.5 w-1.5 -translate-y-1/2 rounded-full bg-white/80 shadow-[0_0_8px_rgba(255,255,255,0.55)]" />
                </span>

                {/* ICON BG */}
                <div className="flex h-full w-full items-center justify-center rounded-full bg-white transition-colors duration-200 group-hover/circle:bg-black/70">

                  <span
                    className="h-7 w-7 bg-purple opacity-90 transition-all duration-200 group-hover/circle:bg-white group-hover/circle:opacity-100 md:h-5 md:w-5 lg:h-6 lg:w-6 xl:h-7 xl:w-7 2xl:h-11 2xl:w-11"
                    style={contactIconStyle}
                  />

                </div>
              </div>

              {/* TEXT */}
              <div className="flex flex-col justify-center text-left md:text-center">

                <h4 className="wrap-break-word font-rajdhani text-lg font-semibold leading-tight text-white md:mt-2 md:text-lg lg:text-lg xl:text-xl 2xl:text-3xl">
                  {item.title}
                </h4>

                <p className="mt-1 xl:max-w-[35vh] 2xl:max-w-[30vh] wrap-break-word font-gilroy-medium text-sm leading-relaxed text-white/85 md:px-1 md:text-sm lg:text-sm xl:text-base 2xl:text-xl">
                  {item.description}
                </p>

              </div>

            </article>
          )
        })}

      </div>
    </section>
  )
}

export default ContactInfoCards